import React from 'react';

import { environment } from '../environments/environment';

import { AdminService } from './admin/AdminService';
import { MetadataService } from './metadata/MetadataService';
import { UserService } from './user/UserService';
import { ApiType } from './ApiType';
import { getSuite, setMainSuite, Suite } from './suite/Suite';
import { PlotsService } from './plots/PlotsService';
import { UserAccount } from '../common/UserAccount';
import { Action } from '../context/GenerateContext';
import { PlotsState, PlotsDispatch } from '../context/plots/PlotsContext';
import { UserPlotsState, UserPlotsDispatch } from '../context/plots/UserPlotsContext';
import { AnalyticsService } from './analytics/AnalyticsService';
import { ChainalysisService } from './chainalysis/ChainalysisService';

class MainSuite implements Suite {
  get userService(): UserService {
    const apiType = environment.userServiceApi as ApiType;
    return getSuite(apiType).userService;
  }
  get adminService(): AdminService {
    const apiType = environment.adminApi as ApiType;
    return getSuite(apiType).adminService;
  }
  get metadataService(): MetadataService {
    const apiType = environment.metadataApi as ApiType;
    return getSuite(apiType).metadataService;
  }
  get plotsService(): PlotsService {
    const apiType = environment.plotsApi as ApiType;
    return getSuite(apiType).plotsService;
  }
  get analyticsService(): AnalyticsService {
    const apiType = environment.analyticsApi as ApiType;
    return getSuite(apiType).analyticsService;
  }

  get chainalysisService(): ChainalysisService {
    const apiType = environment.chainalysisApi as ApiType;
    return getSuite(apiType).chainalysisService;
  }

  setUserState(state: UserAccount): void {
    this.userService.setUserState(state);
    this.adminService.setUserState(state);
    this.plotsService.setUserState(state);
    this.analyticsService.setUserState(state);
  }

  setUserDispatch(dispatch: React.Dispatch<Action>): void {
    this.userService.setDispatch(dispatch);
    this.adminService.setUserDispatch(dispatch);
  }

  setPlotsState(state: PlotsState): void {
    this.plotsService.setPlotsState(state);
  }
  setPlotsDispatch(dispatch: PlotsDispatch): void {
    this.plotsService.setPlotsDispatch(dispatch);
  }
  setUserPlotsState(state: UserPlotsState): void {
    this.plotsService.setUserPlotsState(state);
  }
  setUserPlotsDispatch(dispatch: UserPlotsDispatch): void {
    this.plotsService.setUserPlotsDispatch(dispatch);
  }
}

export const mainSuite = new MainSuite();
setMainSuite(mainSuite);
